import { getSession, type AuthUser } from '@/domains/auth/services/auth.service';
import { mapRoleToUserType, type BackofficeUserType } from '@/backoffice/config/theme';

export interface BackofficeSession {
  user: AuthUser;
  userName: string;
  userType: BackofficeUserType;
  roleCode: string;
}

export function useBackofficeSession(expectedType?: BackofficeUserType): BackofficeSession {
  const session = getSession();
  const user = session?.user ?? ({} as AuthUser);
  const roleCode = session?.roleCode ?? '';
  const userType = mapRoleToUserType(roleCode);

  const userName =
    [user.firstnames, user.lastname].filter(Boolean).join(' ').trim() || 'Utilisateur';

  if (expectedType && userType !== expectedType) {
    // Le guard de route gère la redirection ; on garde le type attendu pour le layout.
    return { user, userName, userType: expectedType, roleCode };
  }

  return { user, userName, userType, roleCode };
}
